import { z } from "zod";

const PaginationSchema = z.object({
    current_page: z.number(),
    from: z.nullable(z.number()),
    to: z.nullable(z.number()),
    total: z.number(),
    per_page: z.number(),
    last_page: z.number(),
    next_page: z.number(),
    prev_page: z.number(),
    path: z.nullable(z.string()),
    next_page_url: z.nullable(z.string()),
    prev_page_url: z.nullable(z.string()),
    first_page_url: z.nullable(z.string()),
    last_page_url: z.nullable(z.string()),
});

export { PaginationSchema };